module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/om-09e65f88432f6b938338e8d055807259.svg";